import {BaseModel} from "../baseModel";
import {UserCategoryResultType} from "../../enums/userCategoryResultType.enum";
import {IsEnum, IsNotEmpty} from "class-validator";
import Category from "../category/category.model";
import Answer from "../answer/answer.model";

class UserCategoryResult extends BaseModel {
    
    userProfileId?: number;
    
    @IsNotEmpty()
    categoryId: number;
    
    category?: Category;
    
    // This is a mapping field used in persona creation for a not logged in user
    categoryName: string;
    
    userResponse?: string;
    
    answerId?: number;
    
    answer?: Answer;

    // This is a mapping field used in persona creation for a not logged in user
    response: string;

    @IsEnum(UserCategoryResultType)
    type: UserCategoryResultType;
}

export { UserCategoryResult }